
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function ParserCreation() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="px-4 py-6">
        <Button variant="outline" onClick={() => navigate('/home')} className="mb-6">
          Back
        </Button>
      </div>
      
      <div className="flex flex-col items-center px-4">
        <div className="w-full max-w-6xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Create Parser</h1>
            <div className="w-full h-px bg-gray-300"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card onClick={() => navigate('/create-new')} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100">
                <i className="ri-add-circle-line text-2xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Create New</h3>
              <p className="text-gray-600">Start fresh with a new parser configuration</p>
            </Card>
            
            <Card onClick={() => navigate('/create-from-existing')} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-cyan-100">
                <i className="ri-file-copy-line text-2xl text-cyan-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Create from Existing</h3>
              <p className="text-gray-600">Modify an existing parser to suit your needs</p>
            </Card>

            <Card onClick={() => navigate('/reserved-formats')} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-amber-100">
                <i className="ri-forbid-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Reserved Formats</h3>
              <p className="text-gray-600">View hardcoded EXP/IMP client names you should not reuse</p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

